/**
 * 繁體中文（台灣）— Traditional Chinese, Taiwan wording.
 * Any key missing here falls back to English (locales/en.js).
 */
export default {
    language: {
        label:  '語言',
        switch: '變更語言',
        names:  { 'en': '英文', 'zh-TW': '繁體中文', 'zh-CN': '簡體中文', 'ja': '日文' },
    },

    suggest: {
        title:   '本網站提供繁體中文版',
        body:    '要切換為繁體中文嗎？您之後隨時可以再變更語言。',
        accept:  '切換為繁體中文',
        decline: '繼續使用英文',
    },

    common: {
        loading:        '載入中...',
        error:          '錯誤',
        no_data:        '沒有資料。',
        day_n:          '第 {n} 天',
        try_again:      '再試一次',
        close:          '關閉',
        skip:           '略過',
        next:           '下一步 >',
        end:            '結束',
        download:       '下載',
        submit:         '送出',
        add:            '新增',
        download_error: '處理檔案時發生問題，請再試一次或聯絡客服。',
    },

    page: {
        home:      '首頁',
        login:     '登入',
        chat:      '聊天',
        quotation: '報價單',
        invoices:  '文件',
        contact:   '聯絡我們',
        help:      '說明',
        faq:       '常見問題',
        access:    '存取權限管理',
        notfound:  '404 頁面',
    },

    nav: {
        groups:    '團體',
        chat:      '聊天',
        documents: '文件',
        support:   '支援',
        help:      '說明',
        faq:       '常見問題',
    },

    breadcrumb: {
        quotations: '報價單列表',
        fit:        'FIT',
        help:       '說明',
        faq:        '常見問題',
    },

    header: {
        available:     '線上',
        manage_access: '管理存取權限',
        logout:        '登出',
    },

    notif: {
        count: '{n} 則新通知',
        empty: '目前沒有通知',
    },

    login: {
        title:        '登入',
        username:     '使用者名稱',
        password:     '密碼',
        button:       '登入',
        loading:      '載入中...',
        err_username: '請輸入使用者名稱',
        err_password: '請輸入密碼',
        err_auth:     '登入失敗，請確認使用者名稱與密碼。',
        by:           'FiveDragons Agency 提供',
    },

    home: {
        loading: '載入中...',
        error:   '錯誤！',
    },

    table: {
        invoice:  '發票編號',
        id:       'ID',
        your_ref: '您的參考編號',
        date:     '日期',
        contact:  '聯絡人',
        status:   '狀態',
        action:   '操作',
        invalid:  '收到的資料無效。',
    },

    status: {
        archived: '已封存',
        go_ahead: '已確認',
        ongoing:  '進行中',
    },

    quotation: {
        title:         '報價單 {ref}',
        loading:       '正在載入報價單...',
        error:         '下載資料時發生錯誤。',
        last_update:   '最新更新',
        loading_short: '（載入中...）',
        show_chat:     '顯示聊天',
        hide_chat:     '隱藏聊天',
        operating_on:  '目前作業中',
        ref:           '編號',
        your_ref:      '您的編號',
        tabs: {
            map:         '地圖',
            itinerary:   '行程',
            hotels:      '飯店',
            restaurants: '餐廳',
            monuments:   '景點',
            rates:       '價格',
            files:       '檔案',
        },
        tour: {
            step1: '詳細資訊都在這些分頁中...',
            step2: '您可以在這裡與您的專員即時交談。',
            step3: '您也可以隱藏聊天視窗，以獲得更多空間。',
        },
    },

    badge: {
        waiting_list:    '候補',
        no_availability: '無空位',
        confirmed:       '已確認',
        canceled:        '已取消',
        on_request:      '待確認',
    },

    hotels: {
        day:    '天數',
        hotel:  '飯店',
        city:   '城市',
        status: '狀態',
    },

    deadlines: {
        deadline:         '取消期限',
        tab:              '取消期限',
        title:            '取消期限（可免費取消至此日期）',
        intro:            '供應商保留訂房至取消期限為止；超過期限後，訂房即為確定，無法取消且必須付款。',
        summary_critical: '{n} 個取消期限在 3 週內',
        summary_warning:  '{n} 個在 2 個月內',
        none_soon:        '未來 2 個月內沒有取消期限。',
        passed:           '已過期',
        none:             '無取消期限',
        supplier:         '供應商',
        type:             '類型',
        city:             '城市',
        day:              '天數',
        date:             '取消期限',
        time_left:        '剩餘時間',
        since:            '保留起始日',
        type_hotel:       '飯店',
        type_restaurant:  '餐廳',
        tooltip:          '可免費取消至 {date}',
        tooltip_since:    '（自 {date} 起保留）',
        legend_critical:  '3 週內',
        legend_warning:   '2 個月內',
        legend_moderate:  '6 個月內',
        legend_safe:      '6 個月以上',
        legend_passed:    '已過期',
    },

    map: {
        loading: '請稍候，地圖載入中...',
        error:   '無法載入預覽。',
        alt:     '地圖',
        title:   '地圖預覽',
    },

    monuments: {
        name:     '名稱',
        location: '位置',
        docs:     '資料',
    },

    rates: {
        unavailable:  '此報價單的價格尚未提供。',
        retry_prefix: '請稍後再試，或',
        contact_us:   '與我們聯絡',
        retry_suffix: '。',
        pax:          '人數',
    },

    restaurants: {
        day:     '天數',
        name:    '名稱',
        status:  '狀態',
        menu_of: '{name} 的菜單 - 第 {day} 天',
    },

    chat: {
        loading:           '載入中...',
        talking_in_prefix: '您正在 ',
        talking_in_suffix: ' 中交談',
        says_prefix:       '',
        says_suffix:       ' 說：',
        uploading:         '上傳中...',
        bad_response:      '伺服器回應異常。',
        placeholder:       '在此輸入訊息...',
        try_again:         '再試一次',
        active:            '線上',
        connecting:        '連線中...',
        done:              '完成',
        error_prefix:      '錯誤：',
        home:              '首頁',
        quotation_prefix:  '報價單/',
    },

    files: {
        error:         '錯誤。',
        loading:       '載入中...',
        empty:         '找不到任何檔案。',
        folder:        '資料夾',
        files:         '檔案',
        folders:       '資料夾',
        last_accessed: '上次存取：',
        count:         '{n} 個檔案',
        group:         '團體 {n}',
        details:       '詳細資料',
        activity:      '活動記錄',
        download:      '下載',
        info:          '資訊',
        type:          '類型',
        size:          '大小',
        location:      '位置',
        created:       '建立時間',
        creation:      '建立',
    },

    access: {
        agents:    '專員',
        none:      '您目前沒有任何專員，請使用下方表單新增。',
        add_title: '新增專員',
        fullname:  '姓名',
        username:  '使用者名稱',
        password:  '密碼',
        add:       '新增',
    },

    help: {
        title:               '說明',
        subject:             '主旨：',
        subject_placeholder: '請輸入主旨',
        message:             '訊息',
        message_placeholder: '請輸入您的訊息',
        submit:              '送出',
    },

    contact: {
        redirecting: '請稍候，正在為您轉址...',
    },

    notfound: {
        title: '404 - 找不到頁面',
        body:  '很抱歉，找不到您要求的頁面。',
    },
};
